'use client';
import { type JSX, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import config from '../config';

const AmplifyConfig = (): JSX.Element => {
  useEffect(() => {
    Amplify.configure({
      API: {
        REST: {
          'portfolio-website': {
            endpoint: config.apiGateway.URL,
            region: config.apiGateway.REGION,
          },
        },
      },
    });
  }, []);

  return <></>;
};

export default AmplifyConfig;
